<template>
  <div id="register">   
    <CustSignupComponent></CustSignupComponent>     
  </div>
</template>

<script>

  import CustSignupComponent from '@/components/cust_components/cust_signup_component.vue';
  
  export default {
      name: 'register',
      data() {
          return {
          }
      },
      components: {     
        CustSignupComponent,
      }
  }
</script>